import { useState, useEffect } from 'react';
import { Consumer, Subscription } from '@rails/actioncable';

export type JackpotView = {
  name: string;
  current_value: number;
};

export type CampaignView = {
  url: string | null;
  currency: string;
  jackpot_views: JackpotView[];
};

const useCampaignViews = (initialValues: CampaignView[]): CampaignView[] => {
  const [campaigns, setCampaignViews] = useState<CampaignView[]>(initialValues);

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription: Subscription = cable.subscriptions.create(
      {
        channel: 'JackpotAggregator::CampaignViewsChannel',
      },
      {
        received: (v) => setCampaignViews(v.data),
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return campaigns;
};

export default useCampaignViews;
